<template>
  <div class="category">
    <span
      class="category-label"
      @click="isOpen = !isOpen">
      <template v-if="checkedServicesCount">
        <el-badge
          :value="checkedServicesCount"
          class="badge">
          {{ category.label }}
        </el-badge>
      </template>
      <template v-else>
        {{ category.label }}
      </template>
      <i
        class="el-icon-arrow-down open-icon"
        :class="{'open': isOpen}" />
    </span>
    <div
      v-show="isOpen"
      class="services">
      <Service
        v-for="service in category.services"
        :key="service.id"
        :service="service"
        :checked-services="checkedServices"
        @update="$emit('update', $event)" />
    </div>
  </div>
</template>

<script>
import Service from "@/components/chatbot/Bubbles/actions/category/Service.vue"

export default {
  name: "Category",
  components: { Service },
  props: {
    category: {
      type: Object,
      required: true
    },
    checkedServices: {
      type: Array,
      required: true
    }
  },
  data() {
    return { isOpen: false }
  },
  computed: {
    checkedServicesCount() {
      let count = 0
      let checkedServicesIds = this.checkedServices.map(service => service.value)

      this.category.services.forEach(service => {
        if (checkedServicesIds.includes(service.id)) {
          count++
        }
      })

      return count
    }
  },
  methods: {
    handleUpdateItem(item) {
      if (!this.checkedServices.includes(item)) {
        this.checkedServices.push(item)
        return
      }
      this.checkedServices.splice(this.checkedServices.indexOf(item), 1)
    }
  }
}
</script>

<style lang="scss">
.category {
  .category-label {
    .badge {
      .el-badge__content {
        top: -2px;
        right: 7px;
        background-color: color(deepSeaBlue);
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.category {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  gap: 5px;

  .category-label {
    font-weight: bold;
    font-size: 18px;
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    color: color(deepSeaBlue);
    cursor: pointer;
    transition: 200ms ease-in-out;
    border-bottom: 1px solid color(gray05);

    &:hover {
      color: color(plainBlack);
    }

    .open-icon {
      display: flex;
      justify-content: center;
      align-items: center;

      &.open {
        transform: rotate(90deg);
      }
    }
  }

  .services {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
</style>
